import enumeration from "./enumeration";

const CreditStatus = {
  NO_REMAINING_BALANCE: "NO_REMAINING_BALANCE",
  WITH_REMAINING_BALANCE: "WITH_REMAINING_BALANCE",
  WITH_PENDING_PAYMENTS: "WITH_PENDING_PAYMENTS",
};

export default enumeration(CreditStatus);
